wbApp.controller('SemesterDetailCtrl', ['$scope', 'semesterSvc',
function ($scope, semesterSvc) {
    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "setting/semesters/semesters-detail-main-tab.html"
        },
        {
            title: "TXT_LBL_SETTING",
            template: "setting/semesters/semesters-detail-setting-tab.html"
        }
    ];

    $scope.detailTabs.activeTab = 0;

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.isSaving = false;

    $scope.onSemesterDetailSave = function (model) {

        $scope.isSaving = true;

        if (!model.id) {
            semesterSvc.insert(model, success, error);
        } else {
            semesterSvc.update(model, success, error);
        }

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
            if (!!$scope.onSaved) {
                $scope.onSaved();
            }
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }
    }

}]);
